import React from 'react';

export function Footer() {

  return (<>
    <div className="text-secondary px-4 text-center">
      <div className="py-0">
        <span className='made-with-love'>Cryptocademia Wallet {process.env.REACT_APP_VERSION} - This dApp is a service offered to users of <a href="https://www.cryptocademia.com" target="_blank" rel="noreferrer">Cryptocademia.com</a></span>
      </div>
    </div>
  </>)
}